import { parseWebClipUrl } from "./web-clip";
import { canvasAssetFileKind } from "./canvas-asset-file";

export type ClipboardPastePayload =
  | { kind: "files"; files: File[] }
  | { kind: "url"; url: URL };

export interface SystemClipboardContents {
  files: File[];
  text: string;
}

type ClipboardData = Pick<DataTransfer, "files" | "getData" | "items">;

export function classifyClipboardPaste(data: ClipboardData | null | undefined): ClipboardPastePayload | null {
  if (!data) return null;

  const itemFiles = Array.from(data.items ?? [])
    .filter((item) => item.kind === "file")
    .map((item) => item.getAsFile())
    .filter((file): file is File => file !== null)
    .filter(isSupportedClipboardAsset);
  const files = itemFiles.length > 0
    ? itemFiles
    : Array.from(data.files ?? []).filter(isSupportedClipboardAsset);

  return classifySystemClipboardContents({ files, text: data.getData("text/plain") });
}

export function classifySystemClipboardContents(contents: SystemClipboardContents): ClipboardPastePayload | null {
  const files = contents.files.filter(isSupportedClipboardAsset);
  if (files.length > 0) return { kind: "files", files };

  const text = contents.text.trim();
  if (!text) return null;
  try {
    return { kind: "url", url: parseWebClipUrl(text) };
  } catch {
    return null;
  }
}

function isSupportedClipboardAsset(file: File): boolean {
  return canvasAssetFileKind(file) !== null;
}
